import { type ReactNode, useEffect, useState } from 'react'

import { StompConnection } from '@/lib/ws/stompClient'
import { StompContext } from '@/lib/ws/stompContext'

interface StompProviderProps {
  children: ReactNode
  /** Connect only once there is a session to authenticate the socket with. */
  enabled?: boolean
  /**
   * Read for every CONNECT frame, including reconnects. Must be a stable
   * reference — it is captured once, when the connection is created.
   */
  getAccessToken?: () => string | null
}

export function StompProvider({ children, enabled = true, getAccessToken }: StompProviderProps) {
  const [connection] = useState(() => new StompConnection({ getAccessToken }))

  useEffect(() => {
    if (!enabled) return

    connection.activate()
    return () => {
      void connection.deactivate()
    }
  }, [connection, enabled])

  return <StompContext.Provider value={connection}>{children}</StompContext.Provider>
}
